var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRnn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RNN"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.6,36.5v29.9H76.8L60.1,36.5v29.9h-8.4V23.7h11.3l16.2,30.4V23.7h11.3l16.2,30.4V23.7h8.4v42.6h-10.8 L87.6,36.5z M15,66.3h9.3V32.5h6.8c4.3,0,6.8,1.3,7.3,3.9c0.5,2,0.2,3.9-2,4.8c-2.8,0.8-5.7,1.2-8.6,1.1h-1.5l12.8,24h11.2 L39.5,48.2h0.3c5.9,0,9.2-4.9,9.2-10.1c0-8.8-4.7-13.6-14.1-14.4H15V66.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRnn);
export default __webpack_public_path__ + "static/media/RNN.f6f86aca8fa03f2aaea84dd30dbccf90.svg";
export { ForwardRef as ReactComponent };